// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const drawingRegisterStyle = theme => ({
	// root: {
	// 	flexGrow: 1,
	// 	backgroundColor: theme.palette.background.paper,
	// },


	// margin: {
	// 	padding:5,
	// 	// margin: 0,
	// 	minHeight: 0,
	// 	minWidth: 0,
	// },


	formControl: {

		
		width: "100%",
	},

	// rootFirstSelect: {
	// 	padding: "0px",
	// 	margin: "0px"
	// },


	rootFirstSelect: {

	 	// paddingTop: "0px",
	 	// marginTop: "0px"

		// paddingTop: 0,
	 	// marginTop: 0


		// display: "flex",
		// alignItems: "center",


	},



})


export default drawingRegisterStyle